import { Component, registerComponent } from "aframe";


export interface InteractiveComponent extends Component
{
	data : {
		label : string;
		icon? : string;
		cursor? : string;
		event : string; //Event to emit when triggered
		endEvent? : string; //Optional event when action stops
		enabled : boolean;
		animation : string;
		vr : boolean; //Enabled in VR
		bubbles : boolean;
	}
}


/*
button can be two things : 
- on an Entity with a hand anchor, an action that can be activated using the thumb
- on a standalone entity, an action can be activated by pressing it
*/
registerComponent("button", {
	schema : { 
		label : { type : "string", default : "Use" },
		icon : { type : "string" },
		cursor : { type : "string" },
		event : { type : "string", default : "activate" },
		endEvent : { type : "string", default : "" },
		enabled : { type : "boolean", default : true },
		animation : { type : "string", default : "Use" },
		vr : { type : "boolean", default : true },
		bubbles : { type : "boolean", default : true }
	},
	update(this : InteractiveComponent)
	{
		this.el.emit("interactions-changed", null, false);
	}
});

/*
on an Entity with a hand anchor, an action that can be activated using the index
*/
registerComponent("trigger", {
	schema : { 
		label : { type : "string", default : "Fire" },
		icon : { type : "string" },
		cursor : { type : "string" },
		event : { type : "string", default : "fire" },
		endEvent : { type : "string", default : "" },
		enabled : { type : "boolean", default : true },
		animation : { type : "string", default : "Fire" },
		vr : { type : "boolean", default : true },
		bubbles : { type : "boolean", default : true }
	},
	update(this : InteractiveComponent)
	{
		this.el.emit("interactions-changed", null, false);
	}
});


/*
on an Entity without a hand anchor, an action that can be activated using the hand (grip)
*/
registerComponent("lever", {
	schema : { 
		label : { type : "string", default : "Use" },
		icon : { type : "string" },
		cursor : { type : "string" },
		event : { type : "string", default : "activate" },
		endEvent : { type : "string", default : "" },
		enabled : { type : "boolean", default : true },
		animation : { type : "string", default : "Use" },
		vr : { type : "boolean", default : true },
		bubbles : { type : "boolean", default : true }
	},
	update(this : InteractiveComponent)
	{
		this.el.emit("interactions-changed", null, false);
	}
});


